:host {
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
}

:host .map-container {
  width: 100%;
  height: 100%;
  position: relative;
}

:host #map {
  height: 100%;
  width: 100%;

  // remove blue focus from google map
  .gm-style iframe + div {
    border: none !important;
  }
}
